module.exports = __webpack_public_path__ + "media/images/writer/community/pc-headline-about-maker@2x-d8e8b07db1e007a32c09d281aa82c050.png";